require("core-js/modules/es.array.push.js");
const Mock = require("mockjs");
const List = [];
const count = 100;
for (let i = 0; i < count; i++) {
  List.push(Mock.mock({
    id: "@increment",
    labelGroupName: "@cword(5, 10)",
    ASFSADF: "1222",
    // labelListS: "@cword(5, 10)",
    "labelList|1-20": [{
      // id: "@increment",
      id: "@integer(300, 5000)",
      labelName: "@cword(5, 10)",
      relateNumber: "@integer(300, 5000)"
    }],
    labelName: "@cword(5, 10)",
    relateNumber: "@integer(300, 5000)"
  }));
}
const articleList = [];
for (let i = 0; i < count; i++) {
  articleList.push(Mock.mock({
    articleDepartmentName: "@cword(5, 10)",
    articleLabelName: "@cword(5, 10)",
    author: "@cname",
    createTime: "@datetime",
    departmentId: "@integer(300, 5000)",
    id: "@increment",
    operatorUserName: "@cname",
    publishTime: "@datetime",
    "state|1": ["DRAFT", "PREPARED", "AVAILABLE"],
    title: "@ctitle"
  }));
}
module.exports = [
  // 角色列表 分页
  // {
  //   url: "/bizc/c/pc/community/content/label/saveOrUpdate",
  //   type: "post",
  //   response: (config) => {
  //     return {
  //       code: 200,
  //       message: "请求成功",
  //       data: true,
  //     };
  //   },
  // },
  // {
  //   url: "/bizc/c/pc/community/content/label/getList",
  //   type: "post",
  //   response: (config) => {
  //     const { banned, keyword, pageNum = 1, pageSize = 10 } = config.query;
  //     let mockList = List.filter((item) => {
  //       // if (banned && item.banned !== banned) return false;
  //       // if (keyword && item.name.indexOf(keyword) < 0) return false;
  //       return true;
  //     });
  //     const pageList = mockList.filter((item, index) => index < pageSize * pageNum && index >= pageSize * (pageNum - 1));
  //     return {
  //       code: 200,
  //       message: "请求成功",
  //       data: {
  //         total: mockList.length,
  //         rows: pageList,
  //       },
  //     };
  //   },
  // },
  // {
  //   url: "/bizc/c/pc/community/content/getPageInfo",
  //   type: "post",
  //   response: (config) => {
  //     const { banned, keyword, pageNum = 1, pageSize = 10 } = config.query;
  //     let mockList = articleList.filter((item) => {
  //       // if (banned && item.banned !== banned) return false;
  //       // if (keyword && item.name.indexOf(keyword) < 0) return false;
  //       return true;
  //     });
  //     const pageList = mockList.filter((item, index) => index < pageSize * pageNum && index >= pageSize * (pageNum - 1));
  //     return {
  //       code: 200,
  //       message: "请求成功",
  //       data: {
  //         total: mockList.length,
  //         rows: pageList,
  //       },
  //     };
  //   },
  // },
];